import axios from "axios";
import { firebaseAuth } from "@/common/firebase";

let apiBaseUrl = "https://gatewaydev.abiinteriors.com/";
if (process.env.NODE_ENV === "production") {
  apiBaseUrl = "https://gateway.abiinteriors.com/";
}

// Create a shared Axios instance
const apiClient = axios.create({
  baseURL: apiBaseUrl
});

// Request interceptor to attach Cognito ID token
apiClient.interceptors.request.use(
  async (config) => {
    try {
      if (firebaseAuth.currentUser) {
        let idToken = await firebaseAuth.currentUser.getIdToken();
        config.headers["x-client-id"] = "content-manager";
        if (idToken) {
          config.headers.Authorization = `Bearer ${idToken}`;
        }
      }
    } catch (error) {
      console.warn("Unable to attach token:", error);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.warn("Unauthorized. You may need to log in again.");
    }
    return Promise.reject(error);
  }
);

export default apiClient;
